// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spa-overlay__page-wrapper--active{max-height:100vh!important;max-width:100vw!important;overflow:hidden!important}.spa-overlay{height:100%;left:0;overflow:hidden;pointer-events:none;position:fixed;top:0;transform:translateZ(0);width:100%}.spa-overlay--menu{height:calc(100% - 80px);overflow:auto;top:80px}.spa-overlay:empty{display:none}.spa-overlay>*{overflow:auto;overscroll-behavior:none;pointer-events:all;-webkit-overflow-scrolling:touch}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
